export default {
  brand_name: 'USFans Spreadsheet',
  nav_spreadsheet: 'Spreadsheet',
  nav_guides: 'Guides',
  nav_reviews: 'Reviews',
  nav_shipping: 'Shipping',
  nav_safety: 'Safety',
  nav_faq: 'FAQ',
  nav_mainWebsite: 'Main Website',
  nav_home: 'Home',
  nav_shoppingGuide: 'Shopping Guide',
  nav_browseCategories: 'Browse Categories',
  read_more: 'Read more',
};